import React, { Component } from 'react';
import MenuList from './MenuList';
import CartPanel from './CartPanel';
import BillingScreen from './BillingScreen';

import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dropdown } from 'primereact/dropdown';
import { Calendar } from 'primereact/calendar';
import { SelectButton } from 'primereact/selectbutton';
import { updateContainerFieldValue } from './containerHelpers';

import { F } from './RestaurantOrderFields';
import { ORDER_TYPES } from '../../Layout/POSSidebar';

const IconOrderInfo = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
        <polyline points="14 2 14 8 20 8" />
        <line x1="16" y1="13" x2="8" y2="13" />
        <line x1="16" y1="17" x2="8" y2="17" />
        <line x1="10" y1="9" x2="8" y2="9" />
    </svg>
);

const IconCustomer = () => (
    <svg width="18" height="18" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
        <circle cx="12" cy="7" r="4" />
    </svg>
);

function formatOrderTime(ts) {
    if (!ts) return '—';
    const d = new Date(ts);
    const date = d.toLocaleDateString(undefined, { day: '2-digit', month: 'short', year: 'numeric' });
    const time = d.toLocaleTimeString(undefined, { hour: '2-digit', minute: '2-digit' });
    return `${date}, ${time}`;
}

const ORDER_TYPE_OPTIONS = [
    {
        label: 'Dine In',
        value: '550e8400-e29b-41d4-a716-446655440001'
    },
    {
        label: 'Take Away',
        value: '550e8400-e29b-41d4-a716-446655440002'
    },
    {
        label: 'Delivery',
        value: '550e8400-e29b-41d4-a716-446655440003'
    },
    {
        label: 'Quick Order',
        value: '550e8400-e29b-41d4-a716-446655440004'
    }
];

class OrderScreen extends Component {
    state = { activeModal: null,
                showBilling: false,
         paymentEntries: [],   // ← add this
        // Only has any visual effect on small screens — the toggle button and
        // the collapsed body are both hidden by CSS above the pos-order-body
        // breakpoint, so desktop always shows the menu list expanded
        // regardless of this value (see _responsive.scss).
        menuCollapsed: false,
     };

    toggleMenuCollapsed = () => this.setState(prev => ({ menuCollapsed: !prev.menuCollapsed }));

//     getTypeLabel() {
//     const option = ORDER_TYPE_OPTIONS.find(
//         x => x.value === this.flat(F.ORDER_TYPE)
//     );

//     return option ? option.label : '';
// }
getTypeLabel() {
    const option = ORDER_TYPE_OPTIONS.find(
        x => x.value === this.props.orderType  // ← use prop, not stageFields
    );
    return option ? option.label : '';
}

    openModal  = (modal) => this.setState({ activeModal: modal });
    closeModal = ()      => this.setState({ activeModal: null });

    // ── Field helpers - read/write straight into RestaurantOrder.js's stageFields ──
    flat = (fieldKey) => this.props.stageFields[fieldKey].FieldValue;
    setFlat = (fieldKey, value) => this.props.onUpdateField(fieldKey, value);

    // Delivery Date comes back from the server as a Date, but a blank value can
    // arrive as '' or an Invalid Date, and Calendar only accepts a real Date or null.
    flatDate = (fieldKey) => {
        const value = this.props.stageFields[fieldKey]?.FieldValue;
        if (!value) return null;
        const date = value instanceof Date ? value : new Date(value);
        return Number.isNaN(date.getTime()) ? null : date;
    };

    row = (containerKey, childKey) => this.props.stageFields[containerKey].ContainerFields[0][childKey].FieldValue;
    setRow = (containerKey, childKey, value) => this.props.onUpdateContainerField(containerKey, childKey, value);

    renderOrderFooter() {
        return (
            <div className="p-d-flex p-jc-end p-gap-2">
                <Button label="Cancel" className="p-button-outlined p-button-danger" onClick={this.closeModal} />
                <Button label="Finish" className="p-button-primary pos-btn-finish" onClick={this.closeModal} />
            </div>
        );
    }

    renderCustomerFooter() {
        return (
            <div className="p-d-flex p-jc-end p-gap-2">
                <Button label="Cancel" className="p-button-danger" onClick={this.closeModal} />
                <Button label="Finish" className="p-button-primary pos-btn-finish" onClick={this.closeModal} />
            </div>
        );
    }

    ToggleBilling = () => {
        this.setState(prev => ({ showBilling: !prev.showBilling }));
    };

    handleBackFromBilling = () => {
        this.setState({ showBilling: false });
    };

   handleCompletePayment = (bill, paymentEntries, changeReturn) => {
    this.setState({ billingSubmitting: true });

    let stageFields = this.state.stageFields;
    stageFields = updateContainerFieldValue(stageFields, F.BILL_SUMMARY, 0, F.BILL_GROSS,          bill.grossAmount);
    stageFields = updateContainerFieldValue(stageFields, F.BILL_SUMMARY, 0, F.BILL_ITEM_DISCOUNT,   bill.itemDiscount);
    stageFields = updateContainerFieldValue(stageFields, F.BILL_SUMMARY, 0, F.BILL_DISCOUNT,        bill.billDiscount);
    stageFields = updateContainerFieldValue(stageFields, F.BILL_SUMMARY, 0, F.BILL_TAX,             bill.tax);
    stageFields = updateContainerFieldValue(stageFields, F.BILL_SUMMARY, 0, F.BILL_SERVICE_CHARGE,  bill.serviceCharge);
    stageFields = updateContainerFieldValue(stageFields, F.BILL_SUMMARY, 0, F.BILL_PACKING_CHARGE,  bill.packingCharge);
    stageFields = updateContainerFieldValue(stageFields, F.BILL_SUMMARY, 0, F.BILL_DELIVERY_CHARGE, bill.deliveryCharge);
    stageFields = updateContainerFieldValue(stageFields, F.BILL_SUMMARY, 0, F.BILL_ROUND_OFF,       bill.roundOff);
    stageFields = updateContainerFieldValue(stageFields, F.BILL_SUMMARY, 0, F.BILL_GRAND_TOTAL,     bill.grandTotal);
    stageFields = updateContainerFieldValue(stageFields, F.PAYMENT_INFO, 0, F.PAY_CHANGE_RETURN,    changeReturn);
    stageFields = updateContainerFieldValue(stageFields, F.PAYMENT_INFO, 0, F.PAY_STATUS,           'Paid');
    stageFields = { ...stageFields, [F.ORDER_STATUS]: { ...stageFields[F.ORDER_STATUS], FieldValue: 'Closed' } };

    // Store payment entries in state so buildRequestActions can read them
    this.setState({ stageFields, paymentEntries }, () => {
        this.saveRequest('submit', 'payment');
        this.setState({ billingSubmitting: false });
        this.closeTable();
    });
};

    render() {
        const {
            table, cartItems, kotItems,
            onBack, onAddToCart, onUpdateQty,
            onRemoveFromCart, onSendToKitchen,onSave, sendingToKitchen,
            onCloseTable, grandTotal, sessionStartTime,
            stageFields,submitting,
            menuitems,
            printKOT,  // ← new: optional function to print KOT
            printBill, // ← new: optional function to print Bill
            isBillGenerated, // ← new: true if a bill already exists for this order/request
            onGoToBill,       // ← new: navigate to the existing bill/billing view
        } = this.props;

        // Guard: if the parent hasn't provided stageFields yet (e.g. this
        // is still wired to the old OrderManagement.js, or renders before
        // RestaurantOrder.js's state is ready), fail safe instead of
        // throwing on this.flat()/this.row().
        if (!stageFields) {
            console.error(
                'OrderScreen: missing "stageFields" prop. ' +
                'Make sure the parent is RestaurantOrder.js (not the old OrderManagement.js) ' +
                'and that it passes stageFields / onUpdateField / onUpdateContainerField.'
            );
            return <div className="pos-order-screen pos-order-screen-error">Loading order…</div>;
        }

        const { activeModal, showBilling, menuCollapsed } = this.state;

        return (
            <div className="pos-order-screen">

                {/* ── HEADER ───────────────────────────────────────────── */}
                <div className="pos-order-header">
                    <div className="pos-header-cell">
                         {onBack && <button className="pos-back-btn" onClick={showBilling ? this.handleBackFromBilling : onBack}>←</button>}
                        <span className="pos-header-type">{this.getTypeLabel()}</span>
                    </div>
                    <div className="pos-header-cell">
                        <span className="pos-header-label">Order No:</span>
                        <span className="pos-header-value">{this.flat(F.ORDER_NUMBER) || 'New Order'}</span>
                    </div>
                    <div className="pos-header-cell">
                        <span className="pos-header-value">{formatOrderTime(sessionStartTime)}</span>
                    </div>
                    <div className="pos-header-cell">
                        <span className="pos-header-label">Guest:</span>
                        <span className="pos-header-value">{this.row(F.CUSTOMER_INFO, F.CUST_NAME) || '—'}</span>
                    </div>
                    <div className="pos-header-cell pos-header-icons">
                        <button className="pos-icon-btn" title="Order Info" onClick={() => this.openModal('order')}>
                            <IconOrderInfo />
                            <span className="pos-icon-label">Order</span>
                        </button>
                        <button className="pos-icon-btn" title="Customer Info" onClick={() => this.openModal('customer')}>
                            <IconCustomer />
                            <span className="pos-icon-label">Customer</span>
                        </button>
                    </div>
                </div>

                {/* ── BODY ─────────────────────────────────────────────── */}
                {/* {showBilling ? ( */}
                     {/* <BillingScreen
                    //     stageFields={stageFields}
                    //     onBack={this.handleBackFromBilling}
                    //     onCompletePayment={this.handleCompletePayment}
                    //     onUpdateContainerField={this.props.onUpdateContainerField}
                    //     submitting={submitting}
                    //     printBill={printBill}
                    // />
                // ) : 
                // ( */}
                <div className="pos-order-body">
                    <div className={`pos-order-left${menuCollapsed ? ' pos-order-left--collapsed' : ''}`}>
                        {/* Toggle only renders/shows on small screens (CSS) — desktop
                            always keeps the menu list expanded. */}
                        <button
                            type="button"
                            className="pos-menu-collapse-toggle"
                            onClick={this.toggleMenuCollapsed}
                            aria-expanded={!menuCollapsed}
                        >
                            <span>Menu</span>
                            <i className={`pi ${menuCollapsed ? 'pi-chevron-down' : 'pi-chevron-up'}`} />
                        </button>
                        <div className="pos-order-left__body">
                            <MenuList onAddToCart={onAddToCart} menuitems={menuitems} />
                        </div>
                    </div>
                    <div className="pos-order-right">
                        <CartPanel
                            cartItems={cartItems}
                            kotItems={kotItems}
                            onUpdateQty={(itemId, delta) => {
                                const item = cartItems.find(i => i.id === itemId);
                                if (item) onUpdateQty(item.__rowIndex, delta);
                            }}
                            onRemoveFromCart={(itemId) => {
                                const item = cartItems.find(i => i.id === itemId);
                                if (item) onRemoveFromCart(item.__rowIndex);
                            }}
                            onSendToKitchen={onSendToKitchen}
                            sendingToKitchen={sendingToKitchen}
                            onSave={onSave}
                            onCloseTable={onCloseTable}
                            onFinish={this.props.onFinish}
                            grandTotal={grandTotal}
                            printKOT={printKOT}  // ← pass down the printKOT function
                            isBillGenerated={isBillGenerated}
                            onGoToBill={onGoToBill} // or whatever navigates to view: 'billing'
                        />
                    </div>
                </div>
                {/* )} */}

                {/* ══ ORDER INFO MODAL ════════════════════════════════════
                    Requested For / Order Type / Branch / Waiter / Cashier / Shift
                    + Table Information container ── */}
                <Dialog
                    header="Order Info."
                    visible={activeModal === 'order'}
                    onHide={this.closeModal}
                    footer={this.renderOrderFooter()}
                    className="pos-info-dialog"
                    dismissableMask
                >
                    <SelectButton
                        value={this.flat(F.ORDER_TYPE)}
                        options={ORDER_TYPE_OPTIONS}
                        onChange={e => this.setFlat(F.ORDER_TYPE, e.value)}
                        className="pos-order-type-tabs mb-3"
                        disabled
                    />

                    <div className="pos-modal-grid">
                        {/* <label className="pos-field-label">Requested For: *</label>
                        <Dropdown
                            value={this.flat(F.REQUESTED_FOR)}
                            options={this.props.Employee || []}
                            onChange={e => this.setFlat(F.REQUESTED_FOR, e.value)}
                            placeholder="Select Employee"
                            className="w-full"
                        /> */}

                        {/* <label className="pos-field-label">Branch: *</label>
                        <Dropdown
                            value={this.flat(F.BRANCH)}
                            options={this.props.Branch || []}
                            onChange={e => this.setFlat(F.BRANCH, e.value)}
                            className="w-full"
                        /> */}

                        <label className="pos-field-label">Waiter:</label>
                        <Dropdown
                            value={this.flat(F.WAITER)}
                            options={this.props.Employee || []}
                            onChange={e => this.setFlat(F.WAITER, e.value)}
                            className="w-full"
                        />

                        {/* <label className="pos-field-label">Cashier:</label>
                        <Dropdown
                            value={this.flat(F.CASHIER)}
                            options={this.props.Employee || []}
                            onChange={e => this.setFlat(F.CASHIER, e.value)}
                            className="w-full"
                        />

                        <label className="pos-field-label">Shift:</label>
                        <Dropdown
                            value={this.flat(F.SHIFT)}
                            options={this.props.Shift || []}
                            onChange={e => this.setFlat(F.SHIFT, e.value)}
                            className="w-full"
                        /> */}

                        <label className="pos-field-label">Token Number:</label>
                        <InputText
                            value={this.flat(F.TOKEN_NUMBER)}
                            onChange={e => this.setFlat(F.TOKEN_NUMBER, e.target.value)}
                            className="w-full"
                            disabled
                        />

                        {/* Table Information */}
                        <label className="pos-field-label">Table No:</label>
                        <InputText
                            value={this.row(F.TABLE_INFO, F.TABLE_NUMBER)}
                            onChange={e => this.setRow(F.TABLE_INFO, F.TABLE_NUMBER, e.target.value)}
                            className="w-full"
                        />

                        <label className="pos-field-label">No. Of Guests:</label>
                        <InputText
                            value={this.row(F.TABLE_INFO, F.NO_OF_GUESTS)}
                            onChange={e => this.setRow(F.TABLE_INFO, F.NO_OF_GUESTS, e.target.value)}
                            keyfilter="int"
                            className="w-full"
                        />

                        <label className="pos-field-label">Adult Count:</label>
                        <InputText
                            value={this.row(F.TABLE_INFO, F.ADULT_COUNT)}
                            onChange={e => this.setRow(F.TABLE_INFO, F.ADULT_COUNT, e.target.value)}
                            keyfilter="int"
                            className="w-full"
                        />

                        <label className="pos-field-label">Child Count:</label>
                        <InputText
                            value={this.row(F.TABLE_INFO, F.CHILD_COUNT)}
                            onChange={e => this.setRow(F.TABLE_INFO, F.CHILD_COUNT, e.target.value)}
                            keyfilter="int"
                            className="w-full"
                        />

                        <label className="pos-field-label">Reservation No:</label>
                        <InputText
                            value={this.row(F.TABLE_INFO, F.RESERVATION_NO)}
                            onChange={e => this.setRow(F.TABLE_INFO, F.RESERVATION_NO, e.target.value)}
                            className="w-full"
                        />
                    </div>
                </Dialog>

                {/* ══ CUSTOMER INFO MODAL ══════════════════════════════════
                    Customer Information container + Delivery Address + Delivery Information ── */}
                <Dialog
                    header="Customer Info."
                    visible={activeModal === 'customer'}
                    onHide={this.closeModal}
                    footer={this.renderCustomerFooter()}
                    className="pos-info-dialog"
                    dismissableMask
                >
                    <div className="pos-modal-grid">
                        <label className="pos-field-label">Name:</label>
                        <InputText
                            value={this.row(F.CUSTOMER_INFO, F.CUST_NAME)}
                            onChange={e => this.setRow(F.CUSTOMER_INFO, F.CUST_NAME, e.target.value)}
                            className="w-full"
                        />

                        <label className="pos-field-label">Mobile:</label>
                        <InputText
                            value={this.row(F.CUSTOMER_INFO, F.CUST_MOBILE)}
                            onChange={e => this.setRow(F.CUSTOMER_INFO, F.CUST_MOBILE, e.target.value)}
                            keyfilter="int"
                            className="w-full"
                        />

                        <label className="pos-field-label">Membership No:</label>
                        <InputText
                            value={this.row(F.CUSTOMER_INFO, F.CUST_MEMBERSHIP_NO)}
                            onChange={e => this.setRow(F.CUSTOMER_INFO, F.CUST_MEMBERSHIP_NO, e.target.value)}
                            className="w-full"
                        />

                        <label className="pos-field-label">GST Number:</label>
                        <InputText
                            value={this.row(F.CUSTOMER_INFO, F.CUST_GST)}
                            onChange={e => this.setRow(F.CUSTOMER_INFO, F.CUST_GST, e.target.value)}
                            className="w-full"
                        />

                        <label className="pos-field-label">Remarks:</label>
                        <InputTextarea
                            value={this.row(F.CUSTOMER_INFO, F.CUST_REMARKS)}
                            onChange={e => this.setRow(F.CUSTOMER_INFO, F.CUST_REMARKS, e.target.value)}
                            rows={2}
                            className="w-full pos-span-right"
                        />
                    </div>

                    {this.flat(F.ORDER_TYPE) === ORDER_TYPES.DELIVERY && (
                        <>
                            <hr className="pos-divider" />
                            <div className="pos-modal-grid">
                                <label className="pos-field-label">Delivery Date:</label>
                                <Calendar
                                    value={this.flatDate(F.DELIVERY_DATE)}
                                    onChange={e => this.setFlat(F.DELIVERY_DATE, e.value || null)}
                                    minDate={new Date(new Date().setHours(0, 0, 0, 0))}
                                    dateFormat="dd/mm/yy"
                                    showIcon
                                    readOnlyInput
                                    // The Dialog clips its content, which crops the calendar
                                    // panel when rendered inline; portal it onto <body> instead.
                                    appendTo={document.body}
                                    className="w-full"
                                />

                                <label className="pos-field-label">Delivery Time:</label>
                                {/* Native time input: its value is already the 24h "HH:mm"
                                    string Expected Delivery Time is stored as. */}
                                <InputText
                                    type="time"
                                    value={this.flat(F.EXPECTED_DELIVERY_TIME) || ''}
                                    onChange={e => this.setFlat(F.EXPECTED_DELIVERY_TIME, e.target.value)}
                                    className="w-full"
                                />

                                <label className="pos-field-label">Address:</label>
                                <InputTextarea
                                    value={this.row(F.DELIVERY_ADDRESS, F.DEL_ADDRESS)}
                                    onChange={e => this.setRow(F.DELIVERY_ADDRESS, F.DEL_ADDRESS, e.target.value)}
                                    rows={2}
                                    className="w-full pos-span-right"
                                />

                                <label className="pos-field-label">LandMark:</label>
                                <InputText
                                    value={this.row(F.DELIVERY_ADDRESS, F.DEL_LANDMARK)}
                                    onChange={e => this.setRow(F.DELIVERY_ADDRESS, F.DEL_LANDMARK, e.target.value)}
                                    className="w-full"
                                />

                                <label className="pos-field-label">Building:</label>
                                <InputText
                                    value={this.row(F.DELIVERY_ADDRESS, F.DEL_BUILDING)}
                                    onChange={e => this.setRow(F.DELIVERY_ADDRESS, F.DEL_BUILDING, e.target.value)}
                                    className="w-full"
                                />

                                <label className="pos-field-label">Floor:</label>
                                <InputText
                                    value={this.row(F.DELIVERY_ADDRESS, F.DEL_FLOOR)}
                                    onChange={e => this.setRow(F.DELIVERY_ADDRESS, F.DEL_FLOOR, e.target.value)}
                                    className="w-full"
                                />

                                <label className="pos-field-label">Door No:</label>
                                <InputText
                                    value={this.row(F.DELIVERY_ADDRESS, F.DEL_DOOR_NO)}
                                    onChange={e => this.setRow(F.DELIVERY_ADDRESS, F.DEL_DOOR_NO, e.target.value)}
                                    className="w-full"
                                />

                                <label className="pos-field-label">Delivery Boy:</label>
                                <Dropdown
                                    value={this.row(F.DELIVERY_INFO, F.DEL_BOY)}
                                    options={this.props.DeliveryBoy || []}
                                    onChange={e => this.setRow(F.DELIVERY_INFO, F.DEL_BOY, e.value)}
                                    className="w-full"
                                />

                                <label className="pos-field-label">Delivery Charge:</label>
                                <InputText
                                    value={this.row(F.DELIVERY_INFO, F.DEL_CHARGE)}
                                    onChange={e => this.setRow(F.DELIVERY_INFO, F.DEL_CHARGE, e.target.value)}
                                    keyfilter="num"
                                    className="w-full"
                                />

                                <label className="pos-field-label">Instructions:</label>
                                <InputTextarea
                                    value={this.row(F.DELIVERY_INFO, F.DEL_INSTRUCTIONS)}
                                    onChange={e => this.setRow(F.DELIVERY_INFO, F.DEL_INSTRUCTIONS, e.target.value)}
                                    rows={2}
                                    className="w-full pos-span-right"
                                />
                            </div>
                        </>
                    )}
                </Dialog>

            </div>
        );
    }
}

export default OrderScreen;
